import { Platform } from "react-native";

export const getPlatform = () => {
	const platform = Platform.OS;

	switch (platform) {
		case "ios":
			return "IOS";
		case "android":
			return "ANDROID";
		default:
			return "WEB";
	}
};

export const isWeb = Platform.OS === "web";
export const isAndroid = Platform.OS === "android";
export const isIOS = Platform.OS === "ios";

const getBrowserType = () => {
	if (!isWeb || typeof navigator === "undefined") {
		return "native";
	}

	const userAgent = navigator.userAgent;

	const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
	const isChromiumBased = /Chrome|Chromium|CriOS/i.test(userAgent) && !isSafari;

	if (isSafari) {
		return "safari";
	}
	if (isChromiumBased) {
		return "chromium";
	}
	return "other";
};

export const isSafari = getBrowserType() === "safari";
export const isChromium = getBrowserType() === "chromium";
